import moment from 'moment';
import { Timescale } from '@contracts';

// This constant defines how many extra days to add
export const bufferDays = 4;

/**
 * Returns a text string representing the delivery date range.
 *
 * @param date - The starting date from which the calculation begins.
 * @param timescale - An object that defines the delivery timescale with properties `timescaleMin` and `timescaleMax`.
 * @param hasBuffer - (Optional) Determines whether a buffer should be added to the dates.
 *
 */
export function getDeliveryDatesText(date: Date, timescale: Timescale, hasBuffer: boolean = false): string {
  const buffer = hasBuffer ? bufferDays : 0;

  const startDate = new Date(date.getTime());
  const endDate = new Date(date.getTime());

  startDate.setDate(startDate.getDate() + buffer + timescale.timescaleMin);
  endDate.setDate(endDate.getDate() + buffer + timescale.timescaleMax);

  // If both dates are in the same month, format like "5-7 March 2023"
  if (moment(startDate).isSame(endDate, 'month')) {
    return `${moment(startDate).format('D')}-${moment(endDate).format('D MMMM Y')}`;
  }

  // Otherwise, format so that both months are indicated, e.g., "5th Mar - 7th Apr 2023"
  return `${moment(startDate).format('Do MMM')} - ${moment(endDate).format('Do MMM Y')}`;
}
